module.exports = __webpack_public_path__ + "img/pro_eight_3.0e1f20b8.jpg";